import React, { useMemo }from 'react';
import { useSelector } from 'react-redux';
import { getBoxscoreState } from './store/selectors/getBoxscoreState';
import Boxscore from './Boxscore';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import boxscore from './store/reducers/boxscore';
import ErrorBoundaryWrapper from '../ErrorFallback/ErrorBoundaryWrapper';

initContainerData.register({
    reducers: { boxscore }
});

const BoxscoreDataContainer = (props) => {
    const {
        boxscore: {
            teams: {
                away = {},
                home = {}
            } = {},
            info = []
        } = {}
    } = useSelector(getBoxscoreState);
    const awayName = away.team?.teamName;
    const homeName = home.team?.teamName;

    const BoxView = useMemo(() => {
        return awayName && homeName ? <Boxscore {...props} awayName={awayName} homeName={homeName} info={info} /> : null
    }, [awayName, awayName, info, props]);


    return (
        <ErrorBoundaryWrapper componentName='Boxscore'>
            {BoxView}
        </ErrorBoundaryWrapper>
    );
};

export default BoxscoreDataContainer;
